













































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import {Sync} from 'vuex-pathify';
import {CONDITIONAL_DISCOUNTS, nil} from '@/common';
@Component({
    components: {
    },
})
export default class PriceTable extends Mixins(CurrencyMixin) {
    @Prop({default: 0})
    public serviceCost!: number;
    @Prop({default: 0})
    public subtotal!: number;
    @Prop({default: 1})
    public proAmount!: number;
    @Prop({default: 0})
    public protip!: number;
    @Prop({default: 0})
    public total!: number;
    @Prop({default: 0})
    public discount!: number;
    @Prop({default: 0})
    public giftCardAmount!: number;
    @Prop({default: false})
    public loading!: boolean;
    @Prop({default: ''})
    public discountDescription!: string;

    public TOSAgree: boolean = false;
    public mounted(){
        this.TOSAgree = false;
    }
    @Sync('booking/discountConditional') public discountConditional!: string;
    public get checkoutDisabled(){
        return this.conditionalDiscountError != false || !this.TOSAgree;
    }
    public get conditionalDiscountError() {
        if (nil(this.discountConditional, true)) {
            return false;
        }
        return CONDITIONAL_DISCOUNTS[this.discountConditional](this.$store.state.booking);
    }
    public tosInError = false;
}
